import { render } from "./RessourcesUsageView.vue?vue&type=template&id=c6f4951c&scoped=true&ts=true"
import script from "./RessourcesUsageView.vue?vue&type=script&lang=ts"
export * from "./RessourcesUsageView.vue?vue&type=script&lang=ts"

import "./RessourcesUsageView.vue?vue&type=style&index=0&id=c6f4951c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6f4951c"]])

export default __exports__